<template>
  <div class="olympiad-blocks">
    <div class="olympiad-blocks__block">
      <h3>
        онлайн-олимпиады разработаны в&nbsp;соответствии
        <span>с&nbsp;федеральными образовательными программами</span>
        дошкольного и&nbsp;школьного образования
      </h3>
      <p>
        Эти&nbsp;занятия способствуют повторению школьной программы и&nbsp;укреплению знаний.
        Помогают развитию нестандартного мышления, а&nbsp;также&nbsp;улучшают внимание,
        логику и&nbsp;пространственное воображение
      </p>
    </div>
    <div class="olympiad-blocks__block">
      <p>
        Выбирайте интересующую вас&nbsp;олимпиаду, регистрируйтесь,
        проходите задания правильно и&nbsp;быстрее всех
      </p>
    </div>
    <div class="olympiad-blocks__block">
      <h3>
        Ну и конечно, выигрывайте <span>призы</span>!
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OlympiadBlocks',
};
</script>

<style scoped lang="scss">

.olympiad-blocks {
  display: grid;
  grid-template-columns: calc(var(--scale) * 863) calc(var(--scale) * 468) calc(var(--scale) * 468);
  grid-template-rows: calc(var(--scale) * 320);
  gap: calc(var(--scale) * 21);

  @include media-down($size-tablet) {
    gap: calc(var(--scale) * 8);
    grid-template-columns: calc(var(--scale) * 363) calc(var(--scale) * 363);
    grid-template-rows: calc(var(--scale) * 233) calc(var(--scale) * 233);
  }

  @include media-down($size-mobile) {
    grid-template-columns: 100%;
    grid-template-rows: calc(var(--scale) * 240) calc(var(--scale) * 240) calc(var(--scale) * 144);
  }

  &__block {
    background-color: #ffffff;
    border-radius: calc(var(--scale) * 60);
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40);
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 20) calc(var(--scale) * 16);
      border-radius: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      background-image: url(/img/materials/olympiad/cups-mob.webp);
    }

    &:nth-child(1) {
      background-image: url(/img/materials/olympiad/vector.webp);
      background-size: auto 100%;
      background-position: right;

      @include media-down($size-tablet) {
        grid-column: 1/3;
      }

      @include media-down($size-mobile) {
        grid-column: 1/2;
        background-image: none;
      }
    }

    &:nth-child(2) {
      background-image: url(/img/materials/olympiad/olympiads.webp);
      background-size: cover;
      background-position: bottom center;

      @include media-down($size-tablet) {
        background-image: url(/img/materials/olympiad/olympiads-tablet.webp);
      }

      @include media-down($size-mobile) {
        background-image: url(/img/materials/olympiad/olympiads-mob.webp);

        p {
          max-width: calc(var(--scale) * 324);
        }
      }
    }

    &:nth-child(3) {
      background-image: url(/img/materials/olympiad/cups.webp);
      background-size: cover;
      background-position: bottom center;

      @include media-down($size-tablet) {
        background-image: url(/img/materials/olympiad/cups-tablet.webp);
      }

      @include media-down($size-mobile) {
        background-image: url(/img/materials/olympiad/cups-mob.webp);

        h3 {
          max-width: calc(var(--scale) * 153);
        }
      }
    }
  }

  h3 {
    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #02120F;

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 670);
      font-size: calc(var(--scale) * 28);
      line-height: 95%;
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 20);
    }

    span {
      color: #FF5319;
    }
  }

  p {
    font-weight: 500;
    font-size: calc(var(--scale) * 20);
    line-height: 120%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 670);
      font-size: calc(var(--scale) * 18);
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 14);
    }
  }
}

</style>
